import { CASES } from './constants';

const initialState = {
    usersList: [],
    filterParam: { roleIds: '8' },
    rangeParam: [0, 499],
    sortParam: ['id', 'DESC'],
};

/**
 * Reducer function to manage the users state in the Redux store.
 *
 * It handles actions related to updating users, filtering users,
 * and clearing users.
 *
 * @param {Object} state - The current state of the users.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the users after applying the action.
 **/
export function users(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_USERS: {
            return { ...state, ...payload };
        }
        case CASES.CLEAR_USERS: {
            return initialState;
        }
        default:
            return state;
    }
}
